import {StepPayload} from '@blesk-frontend/api';
import {createId} from '@paralleldrive/cuid2';
import {toMerged} from 'es-toolkit/object';

/**
 * Creates a step payload.
 * @param payload
 * @returns
 */
export const createStepPayload = (payload: Partial<StepPayload> = {}): StepPayload => {
  const emptyPayload: StepPayload = {
    id: createId(),
    meta: {
      hidden: false,
    },
    src: {
      original: '',
      edited: null,
    },
    page: {
      url: null,
    },
    element: {
      selector: null,
      text: null,
    },
    editor: {
      crop: null,
      rects: [],
    },
  };

  return toMerged(emptyPayload, payload);
};
